import _classCallCheck from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import ChAvueSelectTemplateImpl from "./impl/ChAvueSelectTemplateImpl";
import SupplyAvueSelectTemplateImpl from "./impl/SupplyAvueSelectTemplateImpl";
import PurchaseAvueSelectTemplateImpl from "./impl/PurchaseAvueSelectTemplateImpl";
import ContractAvueSelectTemplateImpl from "./impl/ContractAvueSelectTemplateImpl";
import BudgetAvueSelectTemplateImpl from "./impl/BudgetAvueSelectTemplateImpl";
import PaymentAvueSelectTemplateImpl from "./impl/PaymentAvueSelectTemplateImpl";
import DictionaryAvueSelectTemplateImpl from "./impl/DictionaryAvueSelectTemplateImpl";
var AvueSelectTemplateFactory = /*#__PURE__*/function () {
  function AvueSelectTemplateFactory() {
    _classCallCheck(this, AvueSelectTemplateFactory);
  }
  _createClass(AvueSelectTemplateFactory, null, [{
    key: "newAvueSelectTemplateService",
    value: function newAvueSelectTemplateService(businessTypeKey) {
      if (businessTypeKey === 'ch') {
        return new ChAvueSelectTemplateImpl();
      } else if (businessTypeKey === 'supply') {
        // 供应商和商品
        return new SupplyAvueSelectTemplateImpl();
      } else if (businessTypeKey === 'purchase') {
        // 采购
        return new PurchaseAvueSelectTemplateImpl();
      } else if (businessTypeKey === 'contract') {
        // 合同
        return new ContractAvueSelectTemplateImpl();
      } else if (businessTypeKey === 'budget') {
        // 预算
        return new BudgetAvueSelectTemplateImpl();
      } else if (businessTypeKey === 'payment') {
        // 支出
        return new PaymentAvueSelectTemplateImpl();
      } else if (businessTypeKey === 'dictionary') {
        // 支出
        return new DictionaryAvueSelectTemplateImpl();
      } else {
        throw new Error("\u672A\u627E\u5230\u8BE5\u4E1A\u52A1".concat(businessTypeKey, "\u5BF9\u5E94\u7684\u670D\u52A1"));
      }
    }
  }]);
  return AvueSelectTemplateFactory;
}();
export { AvueSelectTemplateFactory as default };